import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMLoggerService, LMModalWrapperService, LMUrlUtilService } from '@app/services';
import { HttpClient } from '@angular/common/http';
import { LMUniqueIdService } from '@app/utils';
import { LMFieldPickerService } from '@app/components';
import { ListResource } from "@app/resources";

@Injectable()
export class LMBuilderService {

  constructor(
    protected lmUrlUtilService: LMUrlUtilService,
    protected httpClient: HttpClient,
    protected lmLoggerService: LMLoggerService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmFieldPickerService: LMFieldPickerService
  ) {
  }

  public responseHasError(response: any): boolean {
    return (response.status && response.status === "SYSTEM_EXCEPTION");
  }

  public getCreateReportSpecUrl(listResource: ListResource, implementationType: LMBuilderListImplementation, userFolder?: string): string {
    let url = this.lmUrlUtilService.getBuilderUrl('CreateReport');
    url = this.lmUrlUtilService.addParamToUrl(url, 'list', listResource.resourceId);
    url = this.lmUrlUtilService.addParamToUrl(url, 'reporttype', implementationType);

    if (userFolder) {
      url = this.lmUrlUtilService.addParamToUrl(url, 'userfolder', userFolder);
    }

    return url;
  }

  public getCreateReportSpec(listResource: ListResource, implementationType: LMBuilderListImplementation, userFolder?: string): Observable<LMListPSpec> {
    let url = this.getCreateReportSpecUrl(listResource, implementationType, userFolder);
    const params: LMUrlParams = { output: 'spec' };
    url = this.lmUrlUtilService.updateUrlParams(url, params);
    return this.execute(url);
  }

  public getPersonalizeSpecUrl(listResource: ListResource, userFolder: string | undefined): string {
    let url = this.lmUrlUtilService.getBuilderUrl('Personalize');
    url = this.lmUrlUtilService.addParamToUrl(url, 'list', listResource.resourceId);

    if (userFolder) {
      url = this.lmUrlUtilService.addParamToUrl(url, 'userfolder', userFolder);
    }

    return url;
  }

  public getPersonalizeSpec(listResource: ListResource, userFolder: string | undefined): Observable<LMListPSpec>  {
    let  url = this.getPersonalizeSpecUrl(listResource, userFolder);
    const params: LMUrlParams = { output: 'spec' };
    url = this.lmUrlUtilService.updateUrlParams(url, params);
    return this.execute(url);
  }

  public getAdhocColumnarPersonalizeSpec(listResource: ListResource, userFolder: string | undefined): Observable<LMBuilderUpdatePreviewResponse> {
    let  url = this.getPersonalizeSpecUrl(listResource, userFolder);
    const params: LMUrlParams = { requestType: 'adhoc-columnar-report' };
    url = this.lmUrlUtilService.updateUrlParams(url, params);
    return this.execute(url);
  }

  public updateAdhocColumnarPersonalizationSpec(listResource: ListResource, userFolder: string | undefined, chartName: string, spec: LMBusListSpec): Observable<LMBuilderUpdatePreviewResponse> {
    let url = this.getPersonalizeSpecUrl(listResource, userFolder);
    const params: LMUrlParams = { requestType: 'update-columnar-preview' };
    params.chartName = chartName;
    url = this.lmUrlUtilService.updateUrlParams(url, params);

    return this.executePost(url, spec);
  }

  private execute(url: string): Observable<any> {
    return this.httpClient
      .get(url).pipe(
        catchError(error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Server error');
        }));
  }

  private executePost(url: string, payload: any): Observable<any> {
    return this.httpClient
    .post(url, payload).pipe(
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }

  public buildFieldId(builderField: LMBuilderField): string {
    const path: Array<string> = [];
    this._buildFieldId(builderField, path);
    return  path.reverse().join('');
  }

  private _buildFieldId(builderField: LMBuilderField, path: Array<string>) {
    const length = path.length;
    const delimeter = length > 0 ? '.' : '';

    if (builderField.facadeType === 'field' || builderField.facadeType === 'condition') {
      const facadeField = builderField.facade as LMFacadeField;
      path.push(`${facadeField.fieldId}${delimeter}`);
    } else if (builderField.facadeType === 'relation') {
      const facadeRelation = builderField.facade as LMFacadeRelation;
      path.push(`${facadeRelation.relatedLink}${delimeter}`);
    }

    if (builderField.parent) {
      this._buildFieldId(builderField.parent, path);
    }
  }
}
